'use client';

import { useState } from 'react';
import { EditModal } from '@/components/ui/edit-modal';
import { BasicInfoNameField } from '@/features/tournament-wizard/blocks';

interface EditNameModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentName: string;
  onSave: (newName: string) => Promise<boolean>;
  isLoading: boolean;
}

export function EditNameModal({
  isOpen,
  onClose,
  currentName,
  onSave,
  isLoading,
}: EditNameModalProps) {
  const [name, setName] = useState(currentName);

  const handleSave = async () => {
    await onSave(name);
  };

  return (
    <EditModal
      isOpen={isOpen}
      onClose={onClose}
      title="Editar Nombre"
      onSave={handleSave}
      isLoading={isLoading}
    >
      <div className="py-4">
        <BasicInfoNameField
          value={name}
          onChange={setName}
          wrapInCard={false}
          inputId="edit-tournament-name"
        />
      </div>
    </EditModal>
  );
}
